
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ContestPage from '../pages/contest/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/contest',
    element: <ContestPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
